import { render } from "./UnitsDropdown.vue?vue&type=template&id=339afb6e&scoped=true"
import script from "./UnitsDropdown.vue?vue&type=script&lang=js"
export * from "./UnitsDropdown.vue?vue&type=script&lang=js"

import "./UnitsDropdown.vue?vue&type=style&index=0&id=339afb6e&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-339afb6e"]])

export default __exports__